import _defineProperty from "/buddy/remotehvac-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
var genStepsProgressStyle = function genStepsProgressStyle(token) {
  var antCls = token.antCls,
    componentCls = token.componentCls,
    iconSize = token.iconSize,
    iconSizeSM = token.iconSizeSM,
    processIconColor = token.processIconColor,
    marginXXS = token.marginXXS,
    lineWidthBold = token.lineWidthBold,
    lineWidth = token.lineWidth,
    paddingXXS = token.paddingXXS;
  var progressSize = token.calc(iconSize).add(token.calc(lineWidthBold).mul(4).equal()).equal();
  var progressSizeSM = token.calc(iconSizeSM).add(token.calc(token.lineWidth).mul(4).equal()).equal();
  return _defineProperty({}, "&".concat(componentCls, "-with-progress"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-item"), _defineProperty({
    paddingTop: paddingXXS
  }, "&-process ".concat(componentCls, "-item-container ").concat(componentCls, "-item-icon ").concat(componentCls, "-icon"), {
    color: processIconColor
  })), "&".concat(componentCls, "-vertical > ").concat(componentCls, "-item "), _defineProperty({
    paddingInlineStart: paddingXXS
  }, "> ".concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail"), {
    top: marginXXS,
    insetInlineStart: token.calc(iconSize).div(2).sub(lineWidth).add(paddingXXS).equal()
  })), "&, &".concat(componentCls, "-small"), _defineProperty({}, "&".concat(componentCls, "-horizontal ").concat(componentCls, "-item:first-child"), {
    paddingBottom: paddingXXS,
    paddingInlineStart: paddingXXS
  })), "&".concat(componentCls, "-small").concat(componentCls, "-vertical > ").concat(componentCls, "-item > ").concat(componentCls, "-item-container > ").concat(componentCls, "-item-tail"), {
    insetInlineStart: token.calc(iconSizeSM).div(2).sub(lineWidth).add(paddingXXS).equal()
  }), "&".concat(componentCls, "-label-vertical ").concat(componentCls, "-item ").concat(componentCls, "-item-tail"), {
    top: token.calc(iconSize).div(2).add(paddingXXS).equal()
  }), "".concat(componentCls, "-item-icon"), _defineProperty({
    position: 'relative'
  }, "".concat(antCls, "-progress"), {
    position: 'absolute',
    insetInlineStart: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    '&-inner': {
      width: "".concat(unit(progressSize), " !important"),
      height: "".concat(unit(progressSize), " !important")
    }
  })), "&".concat(componentCls, "-small"), _defineProperty(_defineProperty({}, "&".concat(componentCls, "-label-vertical ").concat(componentCls, "-item ").concat(componentCls, "-item-tail"), {
    top: token.calc(iconSizeSM).div(2).add(paddingXXS).equal()
  }), "".concat(componentCls, "-item-icon ").concat(antCls, "-progress-inner"), {
    width: "".concat(unit(progressSizeSM), " !important"),
    height: "".concat(unit(progressSizeSM), " !important")
  })));
};
export default genStepsProgressStyle;